import { render, staticRenderFns } from "./PsPatientEventualInformation.vue?vue&type=template&id=0a05e957&scoped=true&"
import script from "./PsPatientEventualInformation.vue?vue&type=script&lang=js&"
export * from "./PsPatientEventualInformation.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientEventualInformation.vue?vue&type=style&index=0&id=0a05e957&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05e957",
  null
  
)

export default component.exports